document.addEventListener('crPickupActivated', function (e) {
  //jqCR('#pickup-attribute-new').val(1)
  jqCR('#storeUL li a').on('click', function(){    
    const storeID = jqCR(this).attr('data-store-id');
    const address2 = storeID == 6403? 'Unit K140' : 'STE 117'
    

    setTimeout(function(){
        let action = jqCR('#cart_form').attr('action')
        action += '&checkout[shipping_address][address2]=' + address2;     
        jqCR('#cart_form').attr('action', action)
        //console.log(action)
        /console.log()
    }, 500)    
  });
})

